import * as React from 'react';
import { Icon, InputGroup, Popover } from '@mc/react-core';
import { MultiSelectSearch } from './MultiSelectSearch';
import classNames from 'classnames';

const defgetId = (i: any) => i.id;
//const getLabel = (i: any) => i.label;

type Props = {
  onBlur?: (value: any) => void;
  fill?: boolean;
  placeholder?: string;
  disabled?: boolean;
  readOnly?: boolean;
  truncateLength?: number;
} & React.ComponentProps<typeof MultiSelectSearch>;
export const MultiSelectInput: React.FC<Props> = ({
  items,
  value,
  fill,
  getId,
  onBlur,
  truncateLength = 15,
  placeholder,
  disabled,
  readOnly,
  ...other
}) => {
  let val = '';
  if (value && value.length > 0) {
    const valx: undefined | { label: string; id: string }[] = value
      .map((i) => items.find((n) => (getId ? getId : defgetId)(n) === i))
      .filter((i) => !!i) as any;
    if (valx) {
      let i = 0;
      val = valx[i].label;
      for (i = 1; i < valx.length; i++) {
        let newStr = val + ', ' + valx[i].label;
        if (newStr.length > 15) {
          break;
        } else {
          val = newStr;
        }
      }
      if (i < valx.length) {
        val += ' + ' + (valx.length - i);
      }
    }
  }

  return (
    <Popover
      minimal
      fill={fill}
      target={
        <InputGroup
          fill={fill}
          value={val}
          placeholder={placeholder}
          disabled={disabled}
          readOnly={!disabled}
          className={classNames({ 'real-readonly': readOnly })}
          rightElement={<Icon icon="chevron-down" className="mt-1 mr-1" />}
        />
      }
      className="react-final-form-multiselect"
      disabled={disabled || readOnly}
      position="bottom"
      onClose={() => onBlur && onBlur(value)}
      content={
        <MultiSelectSearch
          {...other}
          getId={getId}
          value={value}
          items={items}
        />
      }
    />
  );
};
